import { Box, Card, Stack } from "@vinomofo/components";
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";
import {
  WineClub,
  WineClubFrequency,
  WineClubPreference,
  WineClubVariant,
} from "../../contexts/wine-clubs/types";

import { Button } from "../button";
import { ClubSummary } from "./ClubSummary";
import { navigate } from "gatsby";
import styled from "styled-components";

interface ClubSummaryProps {
  club: WineClub;
  variant: WineClubVariant;
  frequency: WineClubFrequency;
  preference: WineClubPreference;
  headerImage: IGatsbyImageData;
}

const GatsbyImage_ = styled(GatsbyImage)`
  background-color: #131314;
  max-height: 170px;
  height: 100%;
`;

export const ClubCard = ({
  club,
  variant,
  frequency,
  preference,
  headerImage,
}: ClubSummaryProps): JSX.Element => {
  return (
    <Card padding="0" maxWidth="360px" overflow="hidden">
      <Box
        width="100%"
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="space-between"
      >
        <Stack space={3}>
          <GatsbyImage_ image={headerImage} alt="" />

          <Box padding="0 40px">
            <ClubSummary
              club={club}
              variant={variant}
              frequency={frequency}
              preference={preference}
              color="text.heading"
              iconColor="text.heading"
              borderColor="divider"
            />
          </Box>
        </Stack>
        <Box padding="30px 40px">
          <Button
            width="100%"
            onClick={() => navigate(`/wine-clubs/${club.key}`)}
          >
            View club
          </Button>
        </Box>
      </Box>
    </Card>
  );
};
